module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v("\n    Configure Yoco\n    "), (_vm.space && _vm.space.title) ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v("for " + _vm._s(_vm.space.title))]) : _vm._e(), _vm._v(" "), (_vm.isInstalled) ? _c('v-chip', {
    staticClass: "ml-3",
    attrs: {
      "success": "",
      "outline": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v("\n      Connected\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.LINKS.REFERRAL,
      "color": "success",
      "target": "_blank",
      "small": ""
    }
  }, [_vm._v("\n      Open a Yoco account\n      "), _c('v-icon', {
    staticClass: "pl-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": _vm.successMessage,
      "message204": "Successfully uninstalled",
      "message404": "Currently not installed",
      "message201": "Integration installed successfully"
    },
    on: {
      "200": function($event) {
        return _vm.$emit('saved', _vm.request)
      },
      "201": function($event) {
        return _vm.$emit('created', _vm.request)
      },
      "204": function($event) {
        return _vm.$emit('deleted', _vm.request)
      },
      "ok": function($event) {
        return _vm.$emit('ok', _vm.request)
      }
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "type": "info",
      "outline": "",
      "outlined": "",
      "value": true
    }
  }, [_vm._v("\n        You can find your Yoco payment link at:\n          "), _c('a', {
    attrs: {
      "href": _vm.LINKS.REFERRAL
    }
  }, [_vm._v("yoco.co.za")]), _vm._v(" ->\n          sell online ->\n          "), _c('a', {
    attrs: {
      "href": _vm.LINKS.PAYMENT_LINK
    }
  }, [_vm._v("payment page")]), _vm._v(" "), _c('br'), _vm._v("Copy the online link and paste it here\n      ")]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || 'Link is required'; }],
      "prefix": "https://pay.yoco/"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.save.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.link),
      callback: function($$v) {
        _vm.link = $$v
      },
      expression: "link"
    }
  }), _vm._v(" "), (_vm.request.data && _vm.request.result && _vm.request.result.settings) ? [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("Options")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "disabled": _vm.request.loading,
      "label": "Show on invoices",
      "persistent-hint": true,
      "hint": "Will display a button on your invoices which lets your clients pay with Yoco"
    },
    model: {
      value: (_vm.request.data.payment_invoices_visible),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_invoices_visible", $$v)
      },
      expression: "request.data.payment_invoices_visible"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "disabled": _vm.request.loading,
      "label": "Include link on Appointment pages"
    },
    model: {
      value: (_vm.request.data.payment_appointments_visible),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_appointments_visible", $$v)
      },
      expression: "request.data.payment_appointments_visible"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-4 pa-0",
    attrs: {
      "disabled": !(_vm.request.data.payment_appointments_visible) || _vm.request.loading,
      "label": "Allow pre-payments",
      "persistent-hint": true,
      "hint": "Allow people to pay for appointments before the appointment start time"
    },
    model: {
      value: (_vm.request.data.payment_appointments_prepayments),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_appointments_prepayments", $$v)
      },
      expression: "request.data.payment_appointments_prepayments"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-4 pa-0",
    attrs: {
      "disabled": !(_vm.request.data.payment_appointments_visible) || _vm.request.loading,
      "label": "Only allow payments on appointments marked as \"invoiceable\"",
      "persistent-hint": true,
      "hint": "Payment options will not show on the appointment page unless you have explicitly marked the appointment as invoiceable"
    },
    model: {
      value: (_vm.request.data.payment_appointments_only_if_invoiceable),
      callback: function($$v) {
        _vm.$set(_vm.request.data, "payment_appointments_only_if_invoiceable", $$v)
      },
      expression: "request.data.payment_appointments_only_if_invoiceable"
    }
  })] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.isInstalled) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.uninstalldialog = true
      }
    }
  }, [_vm._v("Uninstall")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.isValid,
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "390px"
    },
    model: {
      value: (_vm.uninstalldialog),
      callback: function($$v) {
        _vm.uninstalldialog = $$v
      },
      expression: "uninstalldialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n        Are you sure you want to uninstall Yoco?\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.uninstalldialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.uninstalldialog = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "error"
    },
    on: {
      "click": _vm.uninstall
    }
  }, [_vm._v("Uninstall")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-200d3198","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Yoco.vue
// module id = 1349
// module chunks = 9